// Import styles
import styles from "./CustomerReviewV2.module.css";

// Import comopnents
import HeadingThree from "../HeadingThree";
import ParagraphOne from "../ParagraphOne";
import StarIcon from "../StarIcon";

function CustomerReviewV2({ name, img, children }) {
  return (
    <div className={styles.reviewCard}>
      {/* Customer Picture */}
      <div className={styles.imageContainer}>
        <img
          className={styles.customerImage}
          src={img}
          alt="Customer profile"
        />
      </div>

      {/* Customer Name */}
      <HeadingThree additionalClassNames={styles.customerName}>
        {name}
      </HeadingThree>
      <p className={styles.reviewText}>"{children}"</p>
      <div className={styles.starContainer}>
        <StarIcon className={styles.star} size={33} />
        <StarIcon className={styles.star} size={33} />
        <StarIcon className={styles.star} size={33} />
        <StarIcon className={styles.star} size={33} />
        <StarIcon className={styles.star} size={33} />
      </div>
    </div>
  );
}

export default CustomerReviewV2;
